import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "done_all",
  "use": "done_all-usage",
  "viewBox": "0 0 58 34",
  "content": "<symbol viewBox=\"0 0 58 34\" xmlns=\"http://www.w3.org/2000/svg\" id=\"done_all\">\n<path d=\"M43.7499 4.20844L40.2836 0.742188L24.6978 16.328L28.1641 19.7943L43.7499 4.20844ZM54.1732 0.742188L28.1641 26.7514L17.8882 16.5001L14.422 19.9664L28.1641 33.7084L57.6641 4.20844L54.1732 0.742188ZM0.507812 19.9664L14.2499 33.7084L17.7161 30.2422L3.99865 16.5001L0.507812 19.9664Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol